import { Transition } from "components/shared/column";
import Loader from "components/shared/loader";
import { organizationTypesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import React, { useState } from "react";
import { CustomScroll } from "react-custom-scroll";
import { alert } from "services/alert";
import { generateOrganizationCode, register, setOrganizationInitialSettings } from "sources/admin";

const OrganizationRegistrationForm = (props) => {
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        email: "",
        name: "",
        site: "",
        phoneNumber: "",
        address: "",
        inn: "",
        kpp: "",
        ogrn: "",
        bank: "",
        ks: "",
        rs: "",
        type: organizationTypesEnum.TruckingOrganization,
        password: "",
        confirmPassword: "",
        code: "",
    });

    const submitForm = (e) => {
        e.preventDefault();
        setLoading(true);
        register({ ...formData, kpp: formData.kpp.length > 0 ? formData.kpp : null }).then((res) => {
            setLoading(false);
            if (res) {
                setOrganizationInitialSettings({ organizationId: res.organizationId });
                alert({ type: "success", message: "Компания успешно зарегистрирована.", title: "Успешно!" });
                props.back();
            }
        });
    };

    const onInputChange = (e) => {
        setFormData((prevFormData) => ({ ...prevFormData, [e.target.name]: e.target.value }));
    };

    const close = () => {
        const { history, back } = props;
        back ? back() : history.push(paths.adminOrganizations);
    };

    const generateCode = () => {
        setLoading(true);
        generateOrganizationCode().then((code) => {
            setFormData((prevFormData) => ({ ...prevFormData, code }));
            setLoading(false);
        });
    };

    return (
        <Transition dir="full">
            <div className="page-book__list book-list list book-list--nofilter">
                <div className="book-list__head-wrap border-bottom border-secondary">
                    <div className="book-list__head">
                        <div className="book-list__head-close close close--sm" onClick={close} />
                        <div className="book-list__head-title">Регистрация новой компании</div>
                    </div>
                </div>
                <div className="list__body-wrap">
                    {loading && (
                        <div className="loader-snippet--disable-loader">
                            <Loader />
                        </div>
                    )}
                    <div className="list__body d-flex flex-column">
                        <CustomScroll heightRelativeToParent="100%">
                            <form onSubmit={submitForm} className="identity-form px-4 col-sm-8 offset-sm-2">
                                <div className="w-100">
                                    <div className="identity-column__title pt-4">Информация</div>
                                    <div className="mb-3">
                                        <label className="col-form-label col-form-label-sm">Email</label>
                                        <input
                                            required
                                            className="form-control"
                                            type="email"
                                            value={formData.email}
                                            name="email"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="col-form-label col-form-label-sm">Название компании</label>
                                        <input
                                            required
                                            className="form-control"
                                            value={formData.name}
                                            name="name"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="col-form-label col-form-label-sm">Сайт</label>
                                        <input
                                            className="form-control"
                                            value={formData.site}
                                            name="site"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="col-form-label col-form-label-sm">Телефон</label>
                                        <input
                                            className="form-control"
                                            value={formData.phoneNumber}
                                            name="phoneNumber"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="col-form-label col-form-label-sm">Адрес</label>
                                        <input
                                            className="form-control"
                                            value={formData.address}
                                            name="address"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="col-form-label col-form-label-sm">Код</label>
                                        <input
                                            className="form-control"
                                            value={formData.code}
                                            name="code"
                                            onChange={onInputChange}
                                        />
                                        <small
                                            className="text-primary font-italic cursor-pointer"
                                            onClick={generateCode}
                                        >
                                            Сгенерировать свободный код
                                        </small>
                                    </div>
                                    <div className="identity-column__title pt-4">Реквизиты</div>
                                    <div className="mb-3">
                                        <label className="col-form-label col-form-label-sm">ИНН</label>
                                        <input
                                            className="form-control"
                                            value={formData.inn}
                                            name="inn"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="col-form-label col-form-label-sm">КПП</label>
                                        <input
                                            className="form-control"
                                            value={formData.kpp}
                                            name="kpp"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="col-form-label col-form-label-sm">ОГРН</label>
                                        <input
                                            className="form-control"
                                            value={formData.ogrn}
                                            name="ogrn"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="col-form-label col-form-label-sm">БАНК</label>
                                        <input
                                            className="form-control"
                                            value={formData.bank}
                                            name="bank"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="col-form-label col-form-label-sm">к/с</label>
                                        <input
                                            className="form-control"
                                            value={formData.ks}
                                            name="ks"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="col-form-label col-form-label-sm">р/с</label>
                                        <input
                                            className="form-control"
                                            value={formData.rs}
                                            name="rs"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="w-100">
                                    <div className="mb-3">
                                        <label className="col-form-label col-form-label-sm">Пароль</label>
                                        <input
                                            required
                                            className="form-control"
                                            type="password"
                                            value={formData.password}
                                            name="password"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="col-form-label col-form-label-sm">Подтверждение пароля</label>
                                        <input
                                            required
                                            className="form-control"
                                            type="password"
                                            value={formData.confirmPassword}
                                            name="confirmPassword"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                    <div className="pb-4">
                                        <button
                                            className="identity-form__button identity-form__button--yellow"
                                            type="submit"
                                        >
                                            Зарегистрировать
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </CustomScroll>
                    </div>
                </div>
            </div>
        </Transition>
    );
};

export default OrganizationRegistrationForm;
